import { Component, Host, h, Prop, State } from '@stencil/core';
// import moment from 'moment';
import { DateTime } from "luxon";
import '../loader-component/loader-component'
import '../header-component/header-component';



/**
 
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/announcements-component.PNG)

#### Content Type
nypwebc_ct_announcements
 */



@Component({
  tag: 'announcements-component',
  styleUrl: 'announcements-component.css',
  // shadow: true,
  scoped: true
})
export class AnnouncementsComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
*Optional - To show/hide header. default is true
*/
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;

  /**
  *Optional - number of announcements
  */
  @Prop() count: number = 2;

  /**
 *Optional - To show see All 
 */
  @Prop() seeall: boolean = false;
  /**
 *Optional - see All link Url -  defaul is this.webpath + "/pages/allitems.aspx"
 */
  @Prop() seeallurl: string;

  /**
*Optional - see All link Title
*/
  @Prop() seealltitle: string;



  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
  *Optional -header text color
  */
  @Prop() headertextcolor: string = "black"
  /**
  *Optional -header border bottom css
  */
  @Prop() headerborderbottom: string = "1px solid #CE2127"

  /**
*Optional - is it SP Online site
*/
  @Prop() online: boolean = false;



/**
*Required - site url if its sp online site
*/
@Prop() siteurl: string = "";


  /**
*Optional - single column display
*/
  @Prop() singlecolumn: boolean = false;


  /**
*Optional - single column display
*/
@Prop() imagepos: string = "left"


/**
*Optional - sortversion (itemorder or postdate)
*/
@Prop() sortversion: string = ""



  @State() items: [];
  @State() isLoading: boolean = true;


  componentDidLoad() {


    // let siteUrl: string = "";

    // if (this.online) {
    //   siteUrl = this.siteurl + this.webpath
    // }
    // else {
    //   siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    // }



    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }

    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;
    const filter = "nypwebc_Active eq 1";

    if (this.sortversion === "1")
    {
      return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_ShortDescription,nypwebc_ItemOrder,nypwebc_ImageUrl,nypwebc_ReadMore,nypwebc_PostedDate,nypwebc_Body&$filter=" + filter + "&$orderby=nypwebc_ItemOrder&$top=" + this.count, { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;
      });
    }
    else
    {
      return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_ShortDescription,nypwebc_ItemOrder,nypwebc_ImageUrl,nypwebc_ReadMore,nypwebc_PostedDate,nypwebc_Body&$filter=" + filter + "&$orderby=nypwebc_PostedDate desc&$top=" + this.count, { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;
      });
    }


   

  }

  getContents = (oe) => {
    const contentsArray = []
    this.items.forEach((item: any, index: any) => {

      // let postedDate = moment(item.nypwebc_PostedDate).format("MMMM DD YYYY, h:mm:ss A")

      let postedDate = DateTime.fromISO(item.nypwebc_PostedDate).toLocaleString(DateTime.DATETIME_MED)


      let newsItemUrl=""
      if ((window as any)._spPageContextInfo != null) {
        newsItemUrl= "/Pages/NewsItem.aspx"
      }
      else {
        // let domain = new URL(window.location.href)
        newsItemUrl= "/SitePages/NewsItem.aspx"
      }



      let readMoreUrl = this.webpath + newsItemUrl + "?listname=" + this.listname + "&webpath=" + this.webpath + "&newsid=" + item.ID

      if (item.nypwebc_ReadMore) {
        readMoreUrl = item.nypwebc_ReadMore
      }


      if (oe === 2) {
        if (index % 2 === 0) {
          contentsArray.push(
            <div>
              <a href={readMoreUrl}  target="_blank" data-interception="off" rel="noopener noreferrer" id={item.ID}  >
                <div class="row align-items-center" key={item.ID}>
                  <div class="col-md-12">
                    <h4 style={{ fontSize: "20px", color: "#777777", fontWeight: "600" }}>    {item.Title}  </h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 my-auto" >
                    <img class="rounded mx-auto d-block img-fluid border-0" src={item.nypwebc_ImageUrl} />
                  </div>
                  <div class="col-md-8">
                    <div style={{ fontSize: "16px", color: "#212529" }}>
                      <p>{postedDate}</p>
                      <p> {item.nypwebc_ShortDescription}</p>
                    </div>
                  </div>
                </div>
              </a>
              <hr></hr>
            </div>
          )
        }
      }
      if (oe === 1) {
        if (index % 2 !== 0) {
          contentsArray.push(
            <div>
              <a href={readMoreUrl} target="_blank" data-interception="off"  rel="noopener noreferrer" id={item.ID}  >
                <div class="row align-items-center" key={item.ID}>
                  <div class="col-md-12">
                    <h4 style={{ fontSize: "20px", color: "#777777", fontWeight: "600" }}>    {item.Title}  </h4>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4 my-auto" >
                    <img class="rounded mx-auto d-block img-fluid border-0" src={item.nypwebc_ImageUrl} />
                  </div>
                  <div class="col-md-8">
                    <div style={{ fontSize: "16px", color: "#212529" }}>
                      <p>{postedDate}</p>
                      <p> {item.nypwebc_ShortDescription}</p>
                    </div>
                  </div>
                </div>
              </a>
              <hr></hr>
            </div>
          )
        }
      }

      if (oe === 0) {
        contentsArray.push(
          <div>
            <a href={readMoreUrl}  target="_blank" data-interception="off" rel="noopener noreferrer" id={item.ID}  >
              <div class="row align-items-center" key={item.ID}>
                <div class="col-md-12">
                  <h4 style={{ fontSize: "20px", color: "#777777", fontWeight: "600" }}>    {item.Title}  </h4>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4 my-auto" >
                  <img class="rounded mx-auto d-block img-fluid border-0" src={item.nypwebc_ImageUrl} />
                </div>
                <div class="col-md-8">
                  <div style={{ fontSize: "16px", color: "#212529" }}>
                    <p>{postedDate}</p>
                    <p> {item.nypwebc_ShortDescription}</p>
                  </div>
                </div>
              </div>
            </a>
            <hr></hr>
          </div>
        )

      }

      if (oe === 3) {
        contentsArray.push(
          <div>
            <a href={readMoreUrl}  target="_blank"  data-interception="off" rel="noopener noreferrer" id={item.ID}  >
              <div class="row align-items-center" key={item.ID}>
                <div class="col-md-12">
                  <h4 style={{ fontSize: "20px", color: "#777777", fontWeight: "600" ,marginBottom:"10px",marginTop:"-10px"}}>    {item.Title}  </h4>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 my-auto" >
                  <img class="rounded mx-auto d-block img-fluid border-0" src={item.nypwebc_ImageUrl} />
                </div>
                <div class="col-md-12">
                  <div style={{ fontSize: "16px", color: "#212529" ,marginTop:"20px"}}>
                    <p>{postedDate}</p>
                    <p  style={{ marginTop:"10px"}}> {item.nypwebc_ShortDescription}</p>
                  </div>
                </div>
              </div>
            </a>
           
          </div>
        )

      }

    })
    return contentsArray
  }


  render() {


    let allNewsUrl=""
    if ((window as any)._spPageContextInfo != null) {
      allNewsUrl = this.webpath + "/pages/allitems.aspx"
    }
    else {
      // let domain = new URL(window.location.href)
      allNewsUrl = this.webpath + "/SitePages/allitems.aspx"
    }



    // let allNewsUrl = this.webpath + "/pages/allitems.aspx"
    if (this.seeallurl) {
      allNewsUrl = this.seeallurl

    }

    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        padding:"20px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        padding:"20px"
      }
    }


    return (
      this.singlecolumn ?

        this.isLoading ? <loader-component /> :
          this.header ?
            <div>
              <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seeallurl={allNewsUrl} seealltitle={this.seealltitle} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />

              <div class="row gx-0" style={parentstyle} >
                <div style={styleWithHeader}>
                  <div class="col-md-12">

                    {this.imagepos ==="top" ?
                    this.getContents(3) : this.getContents(0)
                    }
                    
                    </div>
                </div>
              </div>
            </div>
            :
            <div class="row gx-0" style={parentstyle} >
              <div style={style}>
                <div class="col-md-12">
                  {
                  this.imagepos ==="top" ?
                  this.getContents(3)
                  :
                  this.getContents(0)
                  
                  }</div>
              </div>
            </div>



        :

        this.isLoading ? <loader-component /> :
          this.header ?
            <div>
              <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seeallurl={allNewsUrl} seealltitle={this.seealltitle} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />

              <div class="row gx-0" style={parentstyle} >
                <div class="col-md-12" style={styleWithHeader}>
                  <div class="row">
                
                {/* <div style={styleWithHeader}> */}

                  <div class="col-md-6">
                    {this.getContents(2)}</div>
                  <div class="col-md-6">
                    {this.getContents(1)}</div>
                {/* </div> */}
                </div>
                </div>
              </div>
            </div>
            :
            <div class="row gx-0" style={parentstyle} >
               <div class="col-md-12" style={style}>
                  <div class="row">
              {/* <div style={style}> */}
                <div class="col-md-6">
                  {this.getContents(2)}</div>
                <div class="col-md-6">
                  {this.getContents(1)}</div>
              {/* </div> */}
              </div>
              </div>
            </div>
    );
  }

}
